import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ReasonSelector.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { hexToRgb } from '../../../utils/hexToRgb';
import { canUseDOM, get, getPageThemeColors } from '../../../utils';
var checkBox = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\">\n  <g id=\"Group_17086\" data-name=\"Group 17086\" transform=\"translate(-10 -13)\">\n    <circle id=\"Ellipse_2\" data-name=\"Ellipse 2\" cx=\"15\" cy=\"15\" r=\"15\" transform=\"translate(10 13)\" fill=\"#dddede\" opacity=\"0.7\"/>\n    <g id=\"Group_17049\" data-name=\"Group 17049\" transform=\"translate(-368.231 -159.543)\">\n      <path id=\"Path_7104\" data-name=\"Path 7104\" d=\"M0,.094,2.4,0l.02,6.919-2.4.094Z\" transform=\"translate(386.232 188.797) rotate(-45)\" fill=\"currentColor\"/>\n      <path id=\"Path_7105\" data-name=\"Path 7105\" d=\"M0,0,2.029.073,2.5,12.211l.035,2L.511,14.136Z\" transform=\"matrix(0.719, 0.695, -0.695, 0.719, 399.045, 181.756)\" fill=\"currentColor\"/>\n    </g>\n  </g>\n</svg>\n\n";
export var ReasonSelector = function ReasonSelector(_ref) {
  var handleClick = _ref.handleClick,
    id = _ref.id,
    active = _ref.active,
    title = _ref.title,
    showForm = _ref.showForm,
    optionIconSvg = _ref.optionIconSvg,
    englishTitle = _ref.englishTitle;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var renderedTitle = get(title, 'jss.value');
  var icon = get(optionIconSvg, 'jss.value');
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = {
    '--reason-selector-main-01': hexToRgb(selectedPrimaryColor).concat(', 0.1'),
    '--reason-selector-main-05': hexToRgb(selectedPrimaryColor).concat(', 0.5')
  };
  if (!renderedTitle) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: variables
  }, /*#__PURE__*/React.createElement("input", {
    className: "feedback-form__checkbox",
    id: "defaultCheck".concat(id),
    type: "checkbox",
    checked: active,
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        handleClick(id, showForm, englishTitle);
      }
    },
    onChange: function onChange() {
      handleClick(id, showForm, englishTitle);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: "feedback-form__checkbox-label",
    htmlFor: "defaultCheck".concat(id)
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: icon
    },
    className: "icon"
  }), renderedTitle));
};
export var commonStyles = "c9qh39w";
export var ltrStyles = "l9b8ay7";
export var rtlStyles = "rcptsub";
export default ReasonSelector;